<script lang="ts">
	import PageHeader from '$lib/components/page-header.svelte';
</script>

<article>
	<PageHeader>Oh no!</PageHeader>

	<p>It seems like coffee was spilled all over this page, and now it can't be displayed.</p>

	<div class="flex pt-2 pb-5 justify-center">
		<a href="/posts" class="bg-primary px-6 py-2 text-lg text-white rounded-full uppercase"
			>Read posts</a
		>
	</div>
</article>
